import {NgModule} from '@angular/core';
import {CmsConfig, I18nConfig, provideConfig} from '@spartacus/core';
import {userAccountTranslationChunksConfig, userAccountTranslationsDe, userAccountTranslationsEn} from '@spartacus/user/account/assets';
import {USER_ACCOUNT_FEATURE, UserAccountRootModule} from '@spartacus/user/account/root';
import {userProfileTranslationChunksConfig, userProfileTranslationsDe, userProfileTranslationsEn} from '@spartacus/user/profile/assets';
import {USER_PROFILE_FEATURE, UserProfileRootModule} from '@spartacus/user/profile/root';

@NgModule({
  declarations: [],
  imports: [UserAccountRootModule, UserProfileRootModule],
  providers: [
    provideConfig({
      featureModules: {
        [USER_ACCOUNT_FEATURE]: {
          module: () => import('./user-account-wrapper.module').then((m) => m.UserAccountWrapperModule),
        },
      },
    } as CmsConfig),
    provideConfig({
      i18n: {
        resources: {en: userAccountTranslationsEn, de: userAccountTranslationsDe},
        chunks: userAccountTranslationChunksConfig,
      },
    } as I18nConfig),
    provideConfig({
      featureModules: {
        [USER_PROFILE_FEATURE]: {
          module: () => import('./user-profile-wrapper.module').then((m) => m.UserProfileWrapperModule),
        },
      },
    } as CmsConfig),
    provideConfig({
      i18n: {
        resources: {en: userProfileTranslationsEn, de: userProfileTranslationsDe},
        chunks: userProfileTranslationChunksConfig,
      },
    } as I18nConfig),
  ],
})
export class UserFeatureModule {}
